// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1kDAN","wide":"style_wide__1HOG7","buttons":"style_buttons__o7bCK"};